import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

// Kubo 6 - Tento subor musis vykopirovat a premenovat vsetko podla noveho POI (aj nazov suboru).
class PartlyDemolishedInn1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.PARTLY_DEMOLISHED_INN1;
}

export default PartlyDemolishedInn1PoiTileEntity;
